<form [formGroup]="form" class="app-install-trigger-form geofence-entry-trigger-form">

  <app-flow-test-device-section
    [group]="$any(form.get('device'))"
    [modeOptions]="deviceModeOptions"
  ></app-flow-test-device-section>

  <app-flow-test-app-state-section
    [group]="$any(form.get('accountAppDevice'))"
    [modeOptions]="appStateModeOptions"
    [locationPermissionOptions]="locationPermissionOptions"
  ></app-flow-test-app-state-section>

  <app-flow-test-customer-section
    [group]="$any(form.get('accountAppUser'))"
    [modeOptions]="customerModeOptions"
    [userSearchTerm]="userSearchTerm"
    [userSearchResults]="userSearchResults"
    [userSearchLoading]="userSearchLoading"
    [selectedUser]="selectedUser"
    (searchInput)="onUserSearchInput($event)"
    (userPicked)="pickUser($event)"
    (userCleared)="clearUser()"
  ></app-flow-test-customer-section>

  <section formGroupName="locationSample" class="section">
    <header class="section-header">
      <h4>Entry Location</h4>
      <span class="hint">Optional</span>
    </header>

    <div class="mode-toggle">
      <app-trigger-mode-radio-group
        formControlName="mode"
        [options]="locationSampleModeOptions"
      ></app-trigger-mode-radio-group>
    </div>

    <p class="hint" *ngIf="locationSampleMode === 'geofence_center'">
      The sandbox entry history row will use the selected geofence center.
    </p>

    <div class="fields" *ngIf="locationSampleMode === 'specify'">
      <div class="field">
        <label>Latitude</label>
        <mat-form-field appearance="outline">
          <input matInput type="number" formControlName="latitude" placeholder="33.4484" />
        </mat-form-field>
      </div>

      <div class="field">
        <label>Longitude</label>
        <mat-form-field appearance="outline">
          <input matInput type="number" formControlName="longitude" placeholder="-112.0740" />
        </mat-form-field>
      </div>
    </div>

    <p class="hint" *ngIf="locationSampleMode === 'specify'">
      The sandbox entry history row will be saved at these coordinates.
    </p>
  </section>
</form>
